module.exports = __webpack_public_path__ + "img/Mar_Logotipo.07dca52d.png";